module.exports = __webpack_public_path__ + "img/EMC_HG_1.21f76760.png";